import { render, staticRenderFns } from "./CourseManage.vue?vue&type=template&id=6f1dc46c&scoped=true"
import script from "./CourseManage.vue?vue&type=script&lang=js"
export * from "./CourseManage.vue?vue&type=script&lang=js"
import style0 from "./CourseManage.vue?vue&type=style&index=0&id=6f1dc46c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1dc46c",
  null
  
)

export default component.exports